import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, RowDoubleClickedEvent } from 'ag-grid-community';

import { LumCurrencyPipe } from './../../../shared/pipes/lum-currency.pipe';

@Component({
  selector: 'lum-sales-order-ag-invoices',
  templateUrl: './sales-order-ag-invoices.component.html',
  styleUrls: ['./sales-order-ag-invoices.component.scss'],
  providers: [DatePipe, LumCurrencyPipe],
})
export class SalesOrderAgInvoicesComponent implements OnInit, OnChanges {
  @Input()
  salesOrder :any = null;

  columnDefs :ColDef[] = [
    {
      headerName: 'Invoice ID',
      field: 'id',
    },
    {
      headerName: 'Invoice Date',
      field: 'orderDate',
      valueFormatter: (params) => {
        return this.datePipe.transform(params.value, 'mediumDate');
      },
    },
    {
      headerName: 'Invoice Type',
      field: 'invoiceType',
      valueFormatter: (params) => {
        return params.data?.clientPurchaseOrderType?.label || '';
      },
    },
    {
      headerName: 'Client',
      field: 'client',
      valueFormatter: (params) => {
        return params.data?.customer?.businessName || '';
      },
    },
    {
      headerName: 'Shipping Address',
      field: 'completeShippingAddress',
    },
    {
      headerName: 'Gross Total',
      field: 'totalAmount',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(params.value);
      },
    },
    {
      headerName: 'Shipping and Tax Total',
      field: 'shippingAndTaxTotal',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(
          params.data?.shippingAmount + params.data?.taxAmount,
        );
      },
    },
    {
      headerName: 'Discount',
      field: 'discountAmount',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(params.value);
      },
    },
    {
      headerName: 'Net Total',
      field: 'netTotalAmount',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(params.value);
      },
    },
    {
      headerName: 'Payment Term',
      field: 'paymentTermTitle',
    },
    {
      headerName: 'Total Paid',
      field: 'paidAmount',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(params.value);
      },
    },
    {
      headerName: 'Balance Due',
      field: 'balanceDue',
      valueFormatter: (params) => {
        return this.lumCurrencyPipe.transform(
          params.data?.netTotalAmount - params.data?.paidAmount,
        );
      },
    },
    {
      headerName: 'Sync Status',
      field: 'syncStatus',
      cellRenderer: (params :any) => {
        let quickBooksStatusColor = '';
        let shipstationStatusColor = '';

        if (params.data?.quickbooksInvoiceId) {
          quickBooksStatusColor = '#689f60';
        } else if (
          !params.data?.quickbooksInvoiceId &&
          params.data?.quickbooksDetailedMessage
        ) {
          quickBooksStatusColor = '#b22c3e';
        } else if (
          !params.data?.quickbooksInvoiceId &&
          !params.data?.quickbooksDetailedMessage
        ) {
          quickBooksStatusColor = '#54555a';
        }

        if (
          this.salesOrder?.shipstationOrderId ||
          this.salesOrder?.destinationReferenceIdentifier
        ) {
          shipstationStatusColor = 'text-green-700';
        } else if (
          !this.salesOrder?.shipstationOrderId &&
          this.salesOrder?.channelIntegrationTransactions?.length > 0
        ) {
          shipstationStatusColor = 'text-red-700';
        }

        return `
          <div>
            <span>
              <i class="fa fa-shopping-cart text-green-700" aria-hidden="true"></i>
            </span>
            <span>
              <i class="fa fa-cog ${shipstationStatusColor}" aria-hidden="true"></i>
            </span>
            <span>
              <svg width="16" height="16" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>QuickBooks</title>
                <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm.642 4.1335c.9554 0 1.7296.776 1.7296 1.7332v9.0667h1.6c1.614 0 2.9275-1.3156 2.9275-2.933 0-1.6173-1.3136-2.9333-2.9276-2.9333h-.6654V7.3334h.6654c2.5722 0 4.6577 2.0897 4.6577 4.667 0 2.5774-2.0855 4.6666-4.6577 4.6666H12.642zM7.9837 7.333h3.3291v12.533c-.9555 0-1.73-.7759-1.73-1.7332V9.0662H7.9837c-1.6146 0-2.9277 1.316-2.9277 2.9334 0 1.6175 1.3131 2.9333 2.9277 2.9333h.6654v1.7332h-.6654c-2.5725 0-4.6577-2.0892-4.6577-4.6665 0-2.5771 2.0852-4.6666 4.6577-4.6666Z" fill="${quickBooksStatusColor}"></path>
              </svg> 
            </span>
          </div>
        `;
      },
    },
  ];

  constructor(
    private datePipe :DatePipe,
    private lumCurrencyPipe :LumCurrencyPipe,
    private router :Router,
  ) {}

  ngOnInit() :void {}

  ngOnChanges() :void {}

  onRowDoubleClicked(event :RowDoubleClickedEvent) :void {
    const rowData = event.data;
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['clients', 'invoices', rowData.id, 'view']),
    );
    window.open(url, '_blank');
  }
}
